/* unplugin-vue-components disabled */import { render } from "./skill-item.vue?vue&type=template&id=1a1c994e&scoped=true"
import script from "./skill-item.vue?vue&type=script&lang=js"
export * from "./skill-item.vue?vue&type=script&lang=js"

import "./skill-item.vue?vue&type=style&index=0&id=1a1c994e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1c994e"],['__file',"src/pages/settings/admin/test-skills/skill-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a1c994e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a1c994e', __exports__)) {
    api.reload('1a1c994e', __exports__)
  }
  
  module.hot.accept("./skill-item.vue?vue&type=template&id=1a1c994e&scoped=true", () => {
    api.rerender('1a1c994e', render)
  })

}


export default __exports__